// extracted by mini-css-extract-plugin
export default {"customInput2Container":"CustomInput2_customInput2Container__oxtRp","inputClassName":"CustomInput2_inputClassName__McOes"};